import { Component, Input, TemplateRef } from '@angular/core';
import { wizardSteps, wizardStepAction, wizardStepbuttons, wizardHederNavAction } from '../../types/shared-types';
import { Subscription } from 'rxjs';
import { CustomWizardService } from './custom-wizard.service';

@Component({
  selector: 'app-custom-wizard',
  templateUrl: './custom-wizard.component.html',
  styleUrls: ['./custom-wizard.component.scss']
})
export class CustomWizardComponent {

  @Input() steps: wizardSteps[] = [];
  @Input() templates: TemplateRef<any>[] = [];
  @Input() disableNavigation = false;
  activeStepIndex: number = 0;

  private subscriptions$ = new Subscription();

  constructor(
    private customWizardService: CustomWizardService,
  ) { }

  ngOnInit(): void {
    this.subscriptions$.add(this.customWizardService.currentStepIndex$.subscribe((stepIndex: number) => this.getStepIndex(stepIndex)));
  }

  getStepIndex(stepIndex: number) {
    this.resetButtonLoader();
    this.activeStepIndex = stepIndex;
  }

  handleStepsAction(step: wizardSteps, action: wizardStepbuttons) {
    action.submitted = true
    const model: wizardStepAction = {
      title: step.title,
      action: action,
      stepIndex: this.activeStepIndex
    }
    this.customWizardService.handleStepAction(model);
  }

  headerStepNavigation(step: wizardSteps, stepIndex: number) {
    /* If navigation is disabled (`disableNavigation` is true), prevent the event.
       If the clicked step is the current active step (`stepIndex == this.activeStepIndex`), do nothing.
      If the clicked step is a forward step (`stepIndex > this.activeStepIndex`), do nothing, allowing backward navigation only.*/
    if (this.disableNavigation || stepIndex == this.activeStepIndex || this.activeStepIndex < stepIndex) {
      return;
    }
    const model: wizardHederNavAction = {
      title: step.title,
      activeStepIndex: this.activeStepIndex,
      stepIndex: stepIndex,
    }
    this.customWizardService.headerStepNavigation(model);
  }

  resetButtonLoader() {
    this.steps[this.activeStepIndex].actions.map(action => { { action.submitted = false; } })
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
